import './Banner.css'

function Banner(){
    return (
       <header className='banner'>
        <img src="/images/banner.png" alt="main banner"/>
       </header>  
   )
}
export default Banner